import template from './price-currency-text.jade';
import currency from '../../../../enums/currency';
import validation from '../../../../services/validation';

export default angular
  .module('cian.addForm.helperPriceCurrencyText', [])
  .directive('cianAfHelperPriceCurrencyText', ['$sce', $sce => ({
    scope: {},
    transclude: true,
    bindToController: {
      ad: '=',
      form: '=',
      inputName: '@',
      inputModel: '=',
      priceLimit: '@?',
      isRequired: '=?',
      validationMessages: '=?',
      maxLength: '@?'
    },
    controller: ['$scope', 'deviceService', function ($scope, deviceService) {
      this.isMobile = deviceService.isMobile;
      if (!this.ad.bargainTerms) {
        this.ad.bargainTerms = {};
      }

      this.isRequired = angular.isDefined(this.isRequired) ? this.isRequired : true;

      $scope.$watch('priceCurrencyText.ad.bargainTerms.currency', newValue => {
        if (!newValue) return;

        const currencyValue = currency.find(item => {
          return item.key === newValue;
        }).name;

        this.currency = $sce.trustAsHtml(currencyValue);
      });

      this.valueMin = 0;
      this.valueMax = 10e9;
      const valueMaxLength = String(this.valueMax).length - 1;

      let priceValidationMessages = {
        parse: 'Введите число',
        min: 'Цена не может быть отрицательной',
        max: `Допустимо не более ${valueMaxLength} символов`,
        maxlength: `Допустимо не более ${valueMaxLength} символов`,
        required: 'Не указана стоимость',
      };

      // Число выбрано исходя из сообщений выше
      const MAX_VALIDATION_MESSAGE_LENGTH_FOR_TOOLTIP = 50;

      this.shouldTooltipOpen = () => this.validation.message().length <= MAX_VALIDATION_MESSAGE_LENGTH_FOR_TOOLTIP;

      if (angular.isDefined(this.validationMessages)) {
        priceValidationMessages = {
          ...priceValidationMessages,
          ...this.validationMessages
        };
      }

      this.validation = validation(this.form, this.inputName, priceValidationMessages);

      this.maxLength = this.maxlength || 10;

      $scope.$watch('priceCurrencyText.ad.bargainTerms.currency', newValue => {
        const currencyValue = currency.find(item => {
          return item.key === newValue;
        }).name;

        this.currency = $sce.trustAsHtml(currencyValue);
      });
    }],
    controllerAs: 'priceCurrencyText',
    template,
  })])
  .name;
